import { Grid, Tab, Tabs, TextField } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  a11yProps,
  newTiketUsersSchema,
  uploadImageActionRaw,
} from "@/shared";
import {
  useCreateTiketUser,
} from "@/shared/actions/erp/tiketUsers";
import {
  CustomAutocomplete,
  CustomTabPanel,
  CustomTextField,
  SampleDatePicker,
  TabsFormBoxScene,
} from "@/shared/components/ui";
import {

  TiketUsers,
  Departamento,
  UrlFotosTicketType,
  Area,
  Empresa,
} from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFetchAreas, useFetchDepartamentos, usefetchEmpresas } from "@/shared/actions/erp";
import { useUploadImageTicketComponent } from "../components/useuploadImageTiket";
import { useUploadImageStore } from "@/store/erp";

const returnUrlTU = "/tikets/usuarios-tikets/ver";

export interface SaveTiketsUsersProps {
  titlePage: string;
  editTiketUsers?: TiketUsers;
}

type SaveFormData = {
  nombre_requerimento: string;
  descripcion: string;
  imagenes?: UrlFotosTicketType;
  estado_ticket?: string;
  fecha_creacion: string;
  departamento: string;
  empresa: string;
  area: string;
};

const SaveTiketUsersAllActions: React.FC<SaveTiketsUsersProps> = ({
  titlePage,
  editTiketUsers,
}) => {
  const navigate = useNavigate();

  ///* local state


  // tabs
  const [flotaTab, setFlotaTab] = useState(1);
  const handleMethodChange = useCallback((_event: any, value: any) => {
    setFlotaTab(value);
  }, []);

  ///* global state
  const setAlert = useUiStore((s) => s.setAlert);



  ///* fetch data
  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newTiketUsersSchema),
  });
  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = form;
  ///* mutations
  const createTiketUsersMutation = useCreateTiketUser({ navigate, returnUrl: returnUrlTU });
  const {
    UploadImageTicket,
    imagen1,
    setImagen1,
    imagen2,
    setImagen2
  } = useUploadImageTicketComponent();
  const setIsUploadingImgs = useUploadImageStore(s => s.setIsUploading);

  ///* handlers
  const onSave = async () => {
    if (!imagen1 || !imagen2) {
      setAlert(true, "Faltan imagenes por subir", "error");
      return;
    }
    setIsUploadingImgs(true);
    const [
      imagen1Res,
      imagen2Res,
    ] = await Promise.all([
      uploadImageActionRaw({ imageFile: imagen1!, fileName: 'Foto imagen1' }),
      uploadImageActionRaw({ imageFile: imagen2!, fileName: 'Foto imagen2' }),
    ]);
    //const imgaIds=  extractIdsFromObjRes([imagen1Res,imagen2Res]);
    await Promise.all([
      createTiketUsersMutation.mutate({
        ...form.getValues(),
        imagenes: {
          //id_imagen:imgaIds,
          id_imagen: [],
          photosTicket: {
            imagen1: {
              url: imagen1Res.streamUrl!,
              photoId: imagen1Res.id_archivos,
              photoName: imagen1Res.nombre!,
            },
            imagen2: {
              url: imagen2Res.streamUrl!,
              photoId: imagen2Res.id_archivos,
              photoName: imagen2Res.nombre!,
            },
          }
        }
      }),
    ]);

  };
  useEffect(() => {
    reset({
      ...editTiketUsers,
      fecha_creacion: editTiketUsers?.fecha_creacion,
      departamento: editTiketUsers?.departamento,
      descripcion: editTiketUsers?.descripcion,

      nombre_requerimento: editTiketUsers?.nombre_requerimento,
    });
  }, [editTiketUsers, reset]);

  //* axios
  const { data: DepartamentoPaging, isLoading: isLoadingDepartamentos } =
    useFetchDepartamentos({
      page_size: 600,
    });
  const { data: AreasPaging, isLoading: isLoadingAreas } =
    useFetchAreas({
      page_size: 600,
    });
  const { data: EmpresaPaging, isLoading: isLoadingEmpresa } =
    usefetchEmpresas({
      page_size: 600,
    });
  //fetch
  const onChangeDepartamento = (value: string) => {
    form.setValue("departamento", value);
  };
  const onChangeEmpresa = (value: string) => {
    form.setValue("empresa", value);
  };
  const onChangeArea = (value: string) => {
    form.setValue("area", value);
  };
  return (
    <TabsFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlTU);
      }}
      onSave={handleSubmit(onSave, () => {
        setAlert(true, "Faltan campos requeridos", "error");
      })}
      tabs={
        <Tabs
          onChange={handleMethodChange}
          sx={{ mb: 6, pl: "0px" }}
          value={flotaTab}
        >
          <Tab label="Tickets Usuarios" value={1} {...a11yProps(1)} />
        </Tabs>
      }
    >
      {/* =================== TiketUsers =================== */}
      <CustomTabPanel index={flotaTab} value={1}>
        <Grid item xs={12}>
          <SampleDatePicker
            label="fecha de creación"
            control={control}
            error={errors.fecha_creacion}
            helperText={errors.fecha_creacion?.message}
            name="fecha_creacion"
            textFieldKey="fecha_creacion"
            defaultValue={new Date().toISOString().split("T")[0]}
            readonly={true}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTextField
            label="Nombre del requerimiento"
            name="nombre_requerimento"
            control={form.control}
            error={errors.nombre_requerimento}
            helperText={errors.nombre_requerimento?.message}
            type="text"
          />
        </Grid>
        <Grid item xs={12}>
          <CustomAutocomplete<Departamento>
            label="Departamento"
            name="departamento"
            //// options
            options={DepartamentoPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            actualValueKey="codigo"
            //
            defaultValue={form.getValues().departamento || ""}
            optionLabelForEdit={form.getValues().departamento || ""}
            isLoadingData={isLoadingDepartamentos}
            //// validation
            control={form.control}
            error={errors.departamento}
            helperText={errors.departamento?.message}
            onChangeValue={onChangeDepartamento}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomAutocomplete<Area>
            label="Area"
            name="Area"
            //// options
            options={AreasPaging?.data.data || []}
            // label & search by name
            valueKey="nombre"
            actualValueKey="codigo"
            //
            defaultValue={form.getValues().area || ""}
            optionLabelForEdit={form.getValues().area || ""}
            isLoadingData={isLoadingAreas}
            //// validation
            control={form.control}
            error={errors.area}
            helperText={errors.area?.message}
            onChangeValue={onChangeArea}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomAutocomplete<Empresa>
            label="Empresa"
            name="empresa"
            //// options
            options={EmpresaPaging?.data.data || []}
            // label & search by name
            valueKey="razon_social"
            actualValueKey="codigo"
            //
            defaultValue={form.getValues().empresa || ""}
            optionLabelForEdit={form.getValues().empresa || ""}
            isLoadingData={isLoadingEmpresa}
            //// validation
            control={form.control}
            error={errors.empresa}
            helperText={errors.empresa?.message}
            onChangeValue={onChangeEmpresa}
          />
        </Grid>
        <Grid item xs={12} />

        <Grid container spacing={3}>
          <Grid item xs={12}>

            <UploadImageTicket
              buttonText={'imagen 1 del ticket'}
              selectedImage={imagen1}
              setSelectedImage={setImagen1}
            />
          </Grid>

          <Grid item xs={12}>
            <UploadImageTicket
              buttonText={'imagen 2 del ticket'}
              selectedImage={imagen2}
              setSelectedImage={setImagen2}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              {...register("descripcion", { required: "La descripcion es obligatoria" })}
              id="descripcion"
              label="Descripcion"
              fullWidth
              rows={4}
              multiline
              error={Boolean(errors.descripcion)}
              helperText={errors.descripcion?.message}
            />
          </Grid>
        </Grid>
      </CustomTabPanel>
    </TabsFormBoxScene>
  );
};

export default SaveTiketUsersAllActions;
